export default __webpack_public_path__ + "c21aa9f0633971d573f89465b5c7e6f9.png";